module.exports = __webpack_public_path__ + "img/model-2.bf55c0ae.svg";